import { Audited, ID } from '@ianesthesie-kit/services';
import { Patient } from './patient';
import { MedicalComponent } from '@/modules/surgicalEvent';
import { themeColors } from '@ianesthesie-kit/config';

export interface SurgicalEvent extends Audited {
  active: boolean;
  patient: Patient;
  hospitalId: ID;
  status: string;
  validatedAt?: string;
  validatedFrom?: ID;
  patientComments?: string;
  followUpOf?: ID;
  followUpEvent: boolean;
  /** The consultation event this event was created from; its fee and questionnaire live there. */
  consultationOriginId?: ID;
  priority?: Priority;
  priorityModifiedBy?: string;
  staffNotes?: {
    content?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
  };
  contextNotes?: string;
  noKnownMedications?: boolean;
  noPremedication?: boolean;
}

export enum Priority {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  LOW = 'LOW',
  HIGH = 'HIGH',
  URGENT = 'URGENT'
}

export const priorityColors = {
  [Priority.URGENT]: themeColors.red,
  [Priority.HIGH]: themeColors.yellow,
  [Priority.LOW]: themeColors.gray,
  [Priority.NOT_APPLICABLE]: themeColors.slate
};

export interface ImportantElement extends MedicalComponent {
  code: string;
  translationCode: string;
  prependWithTranslation?: string;
  deletable?: boolean;
}

export type FollowUpSurgicalEventPayload = {
  surgeryCodes: string[];
  surgeryDate: string;
  anesthesiaConsultationDate?: string;
  anesthesiaConsultationTime?: string;
  surgeonName?: string;
  anesthesiologistName?: string;
  isPregnant?: boolean;
  urgentCareNeeded?: boolean;
};
